// extracted by mini-css-extract-plugin
module.exports = {"editBox":"editBox_editBox__15GTP","markEdited":"editBox_markEdited__1uUoC"};